import React from 'react';
import pure from 'recompose/pure';
import { Flex, Box } from 'grid-styled';
import IconButton from 'material-ui/IconButton';
import CloseIcon from 'material-ui/svg-icons/navigation/close';

/* Styles */
const MobileToolBar = ({ title, handleClose, style }) => (
  <Flex align="center" justify="space-between" style={style}>
    <Box
      style={{
        width: '90%',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      }}
    >
      {title}
    </Box>
    <Box>
      <IconButton onClick={handleClose}>
        <CloseIcon color={style.color} />
      </IconButton>
    </Box>
  </Flex>
);

export default pure(MobileToolBar);
